
const list = [
  {
    name: '分类管理',
    menuItem: {
      name: '分类管理',
      iconClass: 'icon-material-manage',
      route: '/catergory-list'
    }
  },
  {
    name: '分类列表',
    menuItem: {
      name: '分类列表',
      route: '/catergory-list'
    }
  },
  {
    name: '文件管理',
    menuItem: {
      name: '文件管理',
      iconClass: 'icon-basic-work',
      route: '/file-list'
    }
  },
  {
    name: '文件列表',
    menuItem: {
      name: '文件列表',
      route: '/file-list'
    }
  },
  {
    name: '权限管理',
    menuItem: {
      name: '权限管理',
      iconClass: 'icon-auth-manage',
      route: '/role-manage'
    }
  },
  {
    name: '身份管理',
    menuItem: {
      name: '身份管理',
      route: '/role-manage'
    }
  },
  {
    name: '管理员列表',
    menuItem: {
      name: '管理员列表',
      route: '/admin-list'
    }
  }
];
const mapper = new Map();
list.forEach(value => {
  mapper.set(value.name, value.menuItem);
});

export default mapper;